module.exports = __webpack_public_path__ + "static/media/alcogate-1.f2a35957.jpg";